<template>
  <main class="project" id="projects">
    <h1 id="pTop">All my projects</h1>
    
    <div class="spinerParent" v-if="loading">
      <img src="../assets/spin.png" class="imgRevert" />
    </div>

    <div id="projContainer" v-else>
      <Pagination @pageChanged="changePage($event)" :details="pageDetails" :style="{ margin: '0 0 25px 0' }" v-if="pageDetails" />
      <div class="spinerParent" v-if="loadingPage">
        <img src="../assets/spinb.png" />
      </div>
      <fetchError @ready="catchReady($event)" :style="{display:fetchErr?'flex':'none'}" :Exception="fetchErr" />
      <Project v-for="(project, i) in projects" :key="i" :projectData="project" :tools="tools" />
      <Pagination @pageChanged="changePage($event)" :details="pageDetails" :style="{ margin: '40px 0 10px 0' }" v-if="pageDetails" />
    </div>

  </main>
</template>

<script>
import Request from "../mixins/axiosRequest";
import Project from "../components/Small/Project.vue";
import fetchError from "../components/Small/fetchError.vue";
import Pagination from "../components/Small/Pagination.vue";

import queryPalette from "../mixins/themeColor.js";

const delay = ms => new Promise(res => setTimeout(res, ms));

export default {
  name: "Projects",
  title: "Projects - Nethanzêl's Showroom",
  components: {
    fetchError,
    Project,
    Pagination
  },

  data() {
    return {
      projects: [],
      tools: [],
      loading: true,
      loadingPage: false,
      fetchErr: null,
      pageDetails: undefined
    };
  },

  methods: {
    async getProjects(page) {
      let data = await Request.axiosGet(`/api/projects/${page}`, this.client);
      if(data.status) {
        this.projects = data.data.content;
        this.pageDetails = data.data.meta;
      } else {
        this.fetchErr = data.data;
      }
      this.loading = false;
      this.meshApply();
    },

    async getSkills() {
      let data = await Request.axiosGet("/api/skills", this.client);
      if(data.status) {
        this.tools = data.data[0].technical;
        this.getProjects(1);
      } else {
        this.loading = false;
        this.fetchErr = data.data;
        this.meshApply();
      }
    },

    pluralizeProject(num) {
      if (num == 1) {
        return `+${num} project`;
      } else if (num > 1) {
        return `+${num} projects`;
      }
    },

    catchReady(evt) {
      if(evt && this.fetchErr) {
        evt(this.fetchErr.message , this.fetchErr.name);
      }
    },

    meshApply() {
      queryPalette.generatePalette().then((Palette) => {
        document.querySelector("#projContainer").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#projContainer").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#projContainer").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
      });
    },

    async changePage(index) {
      this.loadingPage = true;
      this.projects = [];

      await delay(250);

      await this.getProjects(index);
      window.scrollTo({top: 0, behavior: 'smooth'});
      this.loadingPage = false;
    }
  },

  async mounted() {
    this.loading = true;
    await this.getSkills();
  }
};
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: dark) {
  #projContainer {
    background-color: #fff;
  }

  h1 {
    color: #fff;
  }
  h1::after {
    border-bottom: 2px solid #fff;
  }

}

@media (prefers-color-scheme: light) {
  #projContainer {
    background-color: #d1d1d1;
  }
  h1 {
    color: #000;
  }
  h1::after {
    border-bottom: 2px solid #000;
  }
  .imgRevert {
    filter: invert(1);
  }
}

.project {
  display: flex;
  flex-direction: column;
  cursor: default;
  max-width: 1366px;
  margin: 0 auto 0 auto;
  padding-top: 60px;
  min-height: 70vh;
}

#projContainer {
  transition: background-color .4s;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  z-index: 5;
  margin: 0 5px;
  padding: 50px 0;
  min-height: 50vh;
  color: #000;
}

h1 {
  letter-spacing: 3px;
  text-align: center;
  width: 100%;
  cursor: default;
  z-index: 10;
  margin-bottom: 45px;
  margin-top: 25px;
  transition: .4s;
}

h1::after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 280px;
  margin-top: 10px;
  transition: .4s;
}

.spinerParent {
  margin: auto 0 auto 0;
}


//====================================================


//====================================================

/* */


@media screen and (max-width: 780px) {

  h1 {
    padding-bottom: 10px;
  }
}

@media screen and (max-width: 445px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    top: 0;
    letter-spacing: 3px;
    font-size: 45px;
  }
}

@media screen and (max-width: 415px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    top: 0;
    letter-spacing: 3px;
    font-size: 45px;
  }
}

@media screen and (max-width: 395px) {
  h1 {
    cursor: default;
    padding-top: 0px;
    text-align: center;
    width: 100%;
    letter-spacing: 3px;
    font-size: 40px;
  }
}

</style>
